import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

/**
 * Single point that configures the Maps JS API for the whole SPA. `setOptions()` must run exactly
 * once and before any library loads; every consumer calls {@link configureGoogle} first, then
 * {@link importLibrary} as needed. Keeping this shared avoids a second `setOptions()` throw.
 *
 * The browser key comes from the authenticated client-config endpoint at runtime (never baked into
 * the bundle); it is exposed to the browser by design and secured by GCP referrer/API restrictions.
 */
let configured = false;

export function configureGoogle(key: string): void {
  if (!configured) {
    setOptions({ key, v: 'weekly' });
    configured = true;
  }
}

export { importLibrary };
